module.exports = __webpack_public_path__ + "static/img/gini.7ad5949.gif";


//////////////////
// WEBPACK FOOTER
// ./static/website/images/gini.gif
// module id = 41ak
// module chunks = 1